import { datadogRum } from '@datadog/browser-rum';
import jwtDecode from 'jwt-decode';

import { JsonTokenDecoded } from '~/types/JsonTokenDecoded';

type TrackerUserParams = {
  accessToken?: string;
};

export const setTrackerUser = ({ accessToken }: TrackerUserParams) => {
  try {
    const jwtUser: JsonTokenDecoded | null = accessToken
      ? jwtDecode(accessToken)
      : null;

    if (jwtUser) {
      setDatadogUser(jwtUser);
      setHeapUser(jwtUser);
    }

    return jwtUser;
  } catch (error) {
    console.error('Error setting tracker user', error);
    return null;
  }
};

async function setDatadogUser(user: JsonTokenDecoded) {
  try {
    datadogRum.setUser({
      id: user?.sub,
      name: user?.preferred_username,
      email: user?.email,
      roles: user?.realm_access,
    });
  } catch (error) {
    console.error('Error setting Datadog user', error);
  }
}

function setHeapUser(user: JsonTokenDecoded) {
  try {
    if (user?.sub) {
      window.heap?.identify(user.sub);
    }
  } catch (error) {
    console.error('Error setting Heap user', error);
  }
}
